import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { api } from "@/lib/api";
import { useSeo, useJsonLd, pageJsonLd } from "@/lib/seo";
import { useHero } from "@/components/site/SiteLayout";
import { Sections } from "@/components/blocks/registry";
import NotFound from "./NotFound";

const PageView = ({ page, preview }) => {
  const setHero = useHero();
  const first = page.sections.find((s) => s.visible !== false);
  const image = page.seo_image || page.sections.find((s) => s.data?.image)?.data.image;
  useSeo(page.seo_title || page.title, page.meta_description, true, { image, noindex: !!preview });
  useJsonLd(preview ? null : pageJsonLd(page, image));
  useEffect(() => { setHero(first?.type === "hero" && first.data.variant === "full"); return () => setHero(false); }, [first, setHero]);
  return (
    <div data-testid={`cms-page-${page.slug}`} className={page.slug === "home" ? "home-page" : ""}>
      {preview && <div className="fixed bottom-4 left-1/2 -translate-x-1/2 z-[60] bg-ink text-ivory text-xs px-4 py-2 rounded-full" data-testid="preview-banner">Anteprima: {preview}</div>}
      <Sections sections={page.sections} page={page} />
    </div>
  );
};

export default function CmsPage({ slug: fixed }) {
  const { slug: param } = useParams();
  const slug = fixed || param;
  const [page, setPage] = useState(undefined);
  useEffect(() => { setPage(undefined); api.get(`/public/pages/${slug}`).then((r) => setPage(r.data)).catch(() => setPage(null)); }, [slug]);
  if (page === null) return <NotFound />;
  if (!page) return <div className="h-screen" />;
  return <PageView page={page} />;
}

export function PagePreview() {
  const { id } = useParams();
  const [page, setPage] = useState(undefined);
  useEffect(() => {
    api.get(`/admin/pages/${id}`).then(({ data }) => {
      const c = data.draft || data.published;
      setPage({ ...c, slug: data.slug, sections: c.sections.filter((s) => s.visible !== false), label: data.draft ? "bozza non pubblicata" : "versione pubblicata" });
    }).catch(() => setPage(null));
  }, [id]);
  if (page === null) return <NotFound />;
  if (!page) return <div className="h-screen" />;
  return <PageView page={page} preview={page.label} />;
}
